import { Link } from 'react-router-dom';

import KassLogo from 'assets/images/kassa-logo.svg';
import KassMiniBlackLogo from 'assets/images/kassa-mini-logo-black.svg';

enum LogoKassaStyle {
  DARK = 'dark',
  LIGHT = 'light',
}
interface LogoKassaProps {
  style?: LogoKassaStyle;
}

const LogoKassa = ({ style = LogoKassaStyle.LIGHT }: LogoKassaProps) => {
  const logoPath = style === LogoKassaStyle.LIGHT ? KassLogo : KassMiniBlackLogo;

  const logoImage = {
    src: logoPath,
    width: 90,
    height: 19,
    alt: 'kassa-logo',
  };

  return (
    <Link to="/">
      <img {...logoImage} alt={logoImage.alt} />
    </Link>
  );
};

export { LogoKassa, LogoKassaStyle };
